import _plugin_vue_export_helper_default from "../../_virtual/_plugin-vue_export-helper.js";
import ScalarDropdownItem_vue_vue_type_script_setup_true_lang_default from "./ScalarDropdownItem.vue_vue_type_script_setup_true_lang.js";
/* empty css                                                                       */
//#region src/components/ScalarDropdown/ScalarDropdownItem.vue
var ScalarDropdownItem_default = /*#__PURE__*/ _plugin_vue_export_helper_default(ScalarDropdownItem_vue_vue_type_script_setup_true_lang_default, [["__scopeId", "data-v-3402682d"]]);
//#endregion
export { ScalarDropdownItem_default as default };

//# sourceMappingURL=ScalarDropdownItem.vue.js.map